// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__X5HD1"};